export default __webpack_public_path__ + "static/ilustration-about-3-154a15596dd1388f22453a0b03c50f08.png";